<template lang="html">
  <el-dialog
    v-if="dialogVisible"
    class="cost-table-dialog"
    title="费用明细"
    width="700px"
    :visible="dialogVisible"
    @close="close"
  >
    <div class="cost-detail-wrapper" v-if="details">
      <div class="cost-content">
        <div class="flowing-item">
          <span>起点：</span>
          <span>{{ details.city_from }}</span>
        </div>
        <div class="flowing-item">
          <span>终点：</span>
          <span>{{ details.city_to }}</span>
        </div>
        <div class="flowing-item">
          <span>承运方：</span>
          <span>{{ details.carrier }}</span>
        </div>
        <div class="flowing-item">
          <span>费用号：</span>
          <span>{{ details.accrualBasisNo }}</span>
        </div>
        <div class="flowing-item">
          <span>订单号：</span>
          <span class="link-url" @click="goOrderDetail">{{
            details.orderNo
          }}</span>
        </div>
        <div class="flowing-item">
          <span>账单号：</span>
          <span class="link-url" @click="goBillDetail">{{
            details.billNo
          }}</span>
        </div>
        <div class="flowing-item">
          <span>确认送达时间：</span>
          <span>{{ details.createTime | timeFormat }}</span>
        </div>
        <div class="flowing-item">
          <span>金额：</span>
          <span>{{ details.totalMoney }}</span>
        </div>
        <div class="flowing-item">
          <span>出账状态：</span>
          <span>{{ details.newStatus }}</span>
        </div>
        <div class="flowing-item">
          <span>状态：</span>
          <span>{{ details.receiptAndPaymentStatus }}</span>
        </div>
        <div class="flowing-item">
          <span>科目：</span>
          <span>{{ details.subject }}</span>
        </div>
        <div class="flowing-item"></div>
        <div class="flowing-item-diff">
          <table>
            <tr>
              <td>货物名</td>
              <td>货物信息</td>
            </tr>
            <tr v-for="(item, index) in details.goods" :key="index">
              <td>{{ item.goodsName }}</td>
              <td>{{ item.info }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    goOrderDetail() {
      this.$router.push({
        name: "orderDetail",
        params: {
          id: this.details.orderNo
        }
      });
    },
    goBillDetail() {
      this.$router.push({
        name: "billDetail",
        params: {
          billNo: this.details.billNo
        }
      });
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.cost-detail-wrapper {
  .cost-content {
    border: 1px solid #e0e0e0;
    padding: 20px 40px;
    display: flex;
    flex-wrap: wrap;
    line-height: 30px;
    .flowing-item {
      width: 50%;
    }
    .flowing-item-diff {
      margin-top: 10px;
      flex: 1;
      table {
        width: 100%;
      }
      td {
        border: 1px solid #e0e0e0;
        text-align: center;
        padding: 4px 8px;
      }
    }
  }
}
</style>

<style lang="scss">
.cost-table-dialog {
  .el-dialog__body {
    padding: 12px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/cost/components/costTable/components/detailDialog/index.vue